var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { breakpoint, FlexItem, NextImg } from '@bfa/common-ui';
import { openWindowUrl } from '@bfa/nextjs-common/utils';
import React from 'react';
import styled from 'styled-components';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import { SOCIAL_POSTS_SECTION_EVENTS as EVENTS } from '../../../../utils/analytics/events';
var StyledGridContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: auto;\n  margin-top: 3.8rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem 0.5rem;\n  @media only screen and (min-width: ", ") {\n    width: 68rem;\n  }\n  @media only screen and (min-width: ", ") {\n    width: 85rem;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"], ["\n  width: 100%;\n  margin: auto;\n  margin-top: 3.8rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem 0.5rem;\n  @media only screen and (min-width: ", ") {\n    width: 68rem;\n  }\n  @media only screen and (min-width: ", ") {\n    width: 85rem;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"])), breakpoint('sm'), breakpoint('md'));
var StyledFlexItem = styled(FlexItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var PostSection = function (_a) {
    var posts = _a.posts;
    var trackEvent = useBusinessConfiguration().trackEvent;
    var handleClick = function (permalink) {
        trackEvent(EVENTS.CLICK_ON_POST);
        openWindowUrl({ url: permalink, target: '_blank' });
    };
    return (React.createElement(StyledGridContainer, null, posts.map(function (_a) {
        var permalink = _a.permalink, mediaUrl = _a.mediaUrl, caption = _a.caption;
        return (React.createElement(StyledFlexItem, { key: mediaUrl, onClick: function () { return handleClick(permalink); } },
            React.createElement(NextImg, { images: [
                    {
                        src: mediaUrl,
                        alt: caption || '',
                        width: 1,
                        height: 1,
                    },
                ], layout: "fill" })));
    })));
};
export default PostSection;
var templateObject_1, templateObject_2;
